import { getParam, isToufangWebView, setStorage, getStorage } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY} from './constant'
import {appConfig} from './app-config'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = IMG_BASE_URL + 'novel-free/';
// https://static.novelfreedom.com/paynovel/h5-pay-asia/
export const getIdfp = () => {
    const idfp = isHasIdfp() || 1
    return idfp
}

// 是否存在idfp
export const isHasIdfp = () => {
    const idfp = getParam('idfp') || getStorage('idfp') || null;
    return idfp
}


// 获取版本号
export const getVersion = () => {
    return '1.0.4'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    const appId = getAppID()
    const idfp = getIdfp()
    return APP_CONFIG[appId]?.['fbPixel'][idfp] || APP_CONFIG[appId]?.['fbPixel'][1] || APP_CONFIG['default']['fbPixel'][1]
}

export const getPathLang = () => {
    const app = getAppID();
    return APP_CONFIG[app]?.lang || APP_CONFIG['default'].lang || 'en'
}

export const getAppID = ()=>{
    if(window.location.origin.includes('novel.lemoncasualhub')){
        return 'novelLemoncasualhub'
    }
    if(window.location.origin.includes('novel.keepreadingbook')){
        return 'novelKeepreadingbook'
    }

    let host = location.host && location.host.split('.'); 
    
    return host.length < 2 ? "" : host[host.length -2];
    // return 'almondnovel'
}

export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}

export const setCookieAdId = () => {
    const adId = getParam('af_ad_id') || getParam('utm_content')
    if (adId) {
        Cookies.set(AD_ID_COOKIES_KEY, adId, { expires: 365, path: '/' });
    }
}

export const APP_CONFIG = {
    ...appConfig
}

export const getAppInfo = () => {
    const appId = getAppID()
    const idfp = getIdfp()
    const obj = {
        name: APP_CONFIG[appId]?.name || APP_CONFIG['default'].name,
        company: APP_CONFIG[appId]?.company || APP_CONFIG['default'].company,
        email: APP_CONFIG[appId]?.email || APP_CONFIG['default'].email,
        fbPixleId: APP_CONFIG[appId]?.['fbPixel'][idfp] || APP_CONFIG[appId]?.['fbPixel']?.[1] || APP_CONFIG['default']['fbPixel'][1],
        lang: APP_CONFIG[appId]?.lang || APP_CONFIG['default'].lang || 'en',
        adx: APP_CONFIG[appId]?.['adx']?.[idfp] || APP_CONFIG[appId]?.['adx']?.[1] || APP_CONFIG['default']['adx'][1],
        content: APP_CONFIG[appId]?.['content']?.[idfp] || APP_CONFIG[appId]?.['content']?.[1] || APP_CONFIG['default']['content'][1],
        adConfig: APP_CONFIG[appId]?.['adConfig']?.[idfp] || APP_CONFIG[appId]?.['adConfig']?.['default'] || APP_CONFIG['default']['adConfig'],
        ga4: APP_CONFIG[appId]?.['ga4'] || APP_CONFIG['default']['ga4'],
        pixelReport: APP_CONFIG[appId]?.['pixelReport']?.[idfp] || APP_CONFIG[appId]?.['pixelReport']?.[1] || APP_CONFIG['default']['pixelReport'],
    }
    return obj
}

export const getAdxConfig = (idfp) => {
    const appId = getAppID()
    if(idfp){
        return APP_CONFIG[appId]?.['adx']?.[idfp] || APP_CONFIG[appId]?.['adx']?.[1] || APP_CONFIG['default']['adx'][1]
    }
    return APP_CONFIG[appId]?.['adx']?.[getIdfp()] || APP_CONFIG[appId]?.['adx']?.[1] || APP_CONFIG['default']['adx'][1]
}

// 是否是投放用户
export const isToufang = () => {
    return false
}

export const isTtChannel = () => {
    return !!getParam('ttclid')
}

